import React from 'react';
import {ReactComponent as ArrowIcon} from 'assets/svgs/actions/arrow.svg';

const Breadcrumb = ({list, onClick, tab}) => (
  <div className="d-flex bg-gray4 breadcrumb-custom border w-100 mr-3">
    <button
      type="button"
      className="d-flex align-items-center px-3 pointer btn-link"
      onClick={() => onClick(null)}
    >
      {tab.label} <ArrowIcon height={15} className="ml-2" />
    </button>

    {list.map((folder, index) => (
      <button
        type="button"
        key={folder._id}
        className={`d-flex align-items-center px-3 btn-link ${
          index === list.length - 1 ? '' : 'pointer'
        } `}
        onClick={() => onClick(folder)}
      >
        {folder.name}
        <ArrowIcon
          height={15}
          className={`ml-2 ${index === list.length - 1 ? 'rotate' : ''}`}
        />
      </button>
    ))}
  </div>
);

export default Breadcrumb;
